import { Icons } from 'pages/Workshop/Icons';
import { showingsFilters } from 'settings/constants/showings';

export const dropdownFields = [
  { itemValue: showingsFilters.myShowings, icon: Icons.USER },
  { itemValue: showingsFilters.allShowings, icon: Icons.TEAM_USER },
];

export const getFilterIcon = (savedValue) => {
  const icons = {
    [showingsFilters.myShowings]: Icons.USER,
    [showingsFilters.allShowings]: Icons.TEAM_USER,
  };

  return icons[savedValue] || Icons.TEAM_USER;
};
